import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Delete, Edit16, Overflow } from 'ui/icons';
import { Body2, spacing } from 'ui/theme';
import { MODAL_NAMES, ModalState, ModalStatePayload } from '../../contexts';
import { ProjectLabel } from '../../types';

const Wrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: ${spacing.quarter} ${spacing.base};
`;

const Name = styled(Body2)`
  margin: 0;
`;

type LabelListRowProps = {
  label: ProjectLabel;
  showModal: (modalState: ModalState<ModalStatePayload>) => void;
};

export const LabelListRow = ({ label, showModal }: LabelListRowProps) => {
  const onClickEdit = () => {
    showModal({
      name: MODAL_NAMES.EDIT_LABEL,
      payload: label,
    });
  };

  const onClickDelete = () => {
    showModal({
      name: MODAL_NAMES.DELETE_LABEL,
      payload: label,
    });
  };

  return (
    <Wrapper role="listitem" aria-labelledby={label.name}>
      <div>
        <Name id={label.name}>{label.name || ''}</Name>
      </div>
      <ActionMenu
        id="overflow-menu"
        align={MENU_ALIGNMENTS.RIGHT}
        options={[
          {
            id: 'edit-label',
            content: (
              <>
                <Edit16 />
                <span>Edit</span>
              </>
            ),
            as: AllowedActionMenuElements.Button,
            onClick: onClickEdit,
          },
          {
            id: 'delete-label',
            isDestructive: true,
            content: (
              <>
                <Delete />
                <span>Delete</span>
              </>
            ),
            as: AllowedActionMenuElements.Button,
            onClick: onClickDelete,
          },
        ]}
      >
        <IconButton size={BUTTON_SIZES.SMALL} type="button" variant={BUTTON_VARIANTS.GHOST}>
          <Overflow />
        </IconButton>
      </ActionMenu>
    </Wrapper>
  );
};
